import * as React from "react";
import { useNavigate } from "react-router-dom";

import { Link as FucLink } from "@frends/ui-components/react";
import { LinkProps } from "@frends/ui-components/react/types/Link";

const Link: React.FC<LinkProps> = (props) => {
    const navigate = useNavigate();

    const handleClick = (
        event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    ) => {
        if (props.onClick) {
            props.onClick(event);
        } else if (props.href) {
            event.preventDefault();
            navigate(props.href);
        }
    };

    return <FucLink {...props} onClick={handleClick} />;
};

export default Link;
